// extracted by mini-css-extract-plugin
export default {"form":"New_form__9tW81","buttonContainer":"New_buttonContainer__JMNJl"};